// relative
import { apiSlice } from '../../apiSlice';

export const sensorsApiSlice = apiSlice.injectEndpoints({
  tagTypes: ['Sensors'],
  endpoints: (builder) => ({
    getSensorsById: builder.query({
      query: (args) => {
        const sensorId = args;
        return {
          url: `/Sensors/${sensorId}`,
        };
      },
      providesTags: ['Sensors'],
    }),
    getRegisterableSensorsByAccountId: builder.query({
      query: (args) => {
        const accountId = args;
        return {
          url: `/Sensors/AccountRegistrable/${accountId}?orderby=SensorId&top=1000`,
        };
      },
      providesTags: ['Sensors'],
    }),
    getSensorConnectionInfoById: builder.query({
      query: ({ sensorId, timestamp }) => ({
        url: `/Sensors/${sensorId}/ConnectionInfo`,
        params: {
          orderby: 'Timestamp',
          Timestamp: `ge(${timestamp})`,
          top: 1000,
        },
      }),

      // providesTags: ['Sensors'],
    }),
    getSensorsByAccountId: builder.query({
      query: (args) => {
        const accountId = args;
        return {
          url: `/Sensors?orderby=SensorId&Account.AccountId=eq(${accountId})&top=10000`,
        };
      },
      providesTags: ['Sensors'],
    }),
    getPowerDisaggregation: builder.query({
      query: () => {
        return {
          url: `/Sensors/Calibrate/PowerDisaggregation?orderby=PowerDisaggregationId&top=10000`,
        };
      },
      providesTags: ['PowerDisaggregation'],
    }),
    getPowerDisaggregationByAccountId: builder.query({
      query: (args) => {
        const accountId = args;
        return {
          url: `/Sensors/Calibrate/PowerDisaggregation?orderby=PowerDisaggregationId&Account.AccountId=eq(${accountId})&top=10000`,
        };
      },
      providesTags: ['PowerDisaggregation'],
    }),
    getPowerDisaggregationById: builder.query({
      query: (args) => {
        const powerDisaggregationId = args;
        return {
          url: `/Sensors/Calibrate/PowerDisaggregation/${powerDisaggregationId}`,
        };
      },
      providesTags: ['PowerDisaggregation'],
    }),
    postPowerDisaggregation: builder.mutation({
      query: (powerDisaggregation) => ({
        url: '/Sensors/Calibrate/PowerDisaggregation',
        method: 'POST',
        body: { ...powerDisaggregation },
      }),
      invalidatesTags: ['PowerDisaggregation'],
      transformResponse: (response, meta) => {
        // Access the Location header
        const locationHeader = meta?.response?.headers.get('Location');
        // Return the original response and the extracted ID
        return { data: response, location: locationHeader };
      },
    }),
    updatePowerDisaggregation: builder.mutation({
      query: ({ id, patch }) => ({
        url: `/Sensors/Calibrate/PowerDisaggregation/${id}`,
        method: 'PUT',
        body: JSON.stringify(patch),
      }),
      invalidatesTags: ['PowerDisaggregation'],
      transformResponse: (response, meta) => {
        // Access the Location header
        const locationHeader = meta?.response?.headers.get('Location');
        // Return the original response and the extracted ID
        return { data: response, location: locationHeader };
      },
    }),
    postStartPowerDisaggregation: builder.mutation({
      query: ({ powerDisaggregationId, subMeterFilter }) => ({
        url: `/Sensors/Calibrate/PowerDisaggregation/${powerDisaggregationId}/Start`,
        method: 'POST',
        body: JSON.stringify(subMeterFilter),
      }),
      invalidatesTags: ['PowerDisaggregation'],
      transformResponse: (response, meta) => {
        // Access the Location header
        const locationHeader = meta?.response?.headers.get('Location');
        // Return the original response and the extracted ID
        return { data: response, location: locationHeader };
      },
    }),
    patchSensor: builder.mutation({
      query: ({ id, patch }) => ({
        url: `/Sensors/${id}`,
        method: 'PATCH',
        body: patch,
      }),
      invalidatesTags: ['Sensors'],
    }),
    deleteSensor: builder.mutation({
      query: (id) => ({
        url: `/Sensors/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Sensors'],
    }),
  }),
});

export const {
  useGetSensorsByIdQuery,
  useLazyGetSensorsByIdQuery,
  useGetSensorConnectionInfoByIdQuery,
  useGetRegisterableSensorsByAccountIdQuery,
  useLazyGetRegisterableSensorsByAccountIdQuery,
  useGetPowerDisaggregationQuery,
  useGetPowerDisaggregationByAccountIdQuery,
  usePostPowerDisaggregationMutation,
  useGetSensorsByAccountIdQuery,
  useLazyGetSensorsByAccountIdQuery,
  useUpdatePowerDisaggregationMutation,
  usePostStartPowerDisaggregationMutation,
  useGetPowerDisaggregationByIdQuery,
  usePatchSensorMutation,
  useDeleteSensorMutation,
} = sensorsApiSlice;
